/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import Stack from '@mui/material/Stack';
import { useState } from 'react';
import ButtonPrimary from 'components/Buttons/ButtonPrimary/ButtomPrimary.component';
import TextInputField from 'components/inputs/TextField/TextField.component';
import { FormGlobal } from 'styles/Global.styles';
import { maskInput, useScreenSize } from 'utils/helpers';
import { maskCpfCnpj } from 'utils/maskCpfCnpj';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { TableCadastroProps } from '@typings/componentables';
import { useApi } from 'hooks/userApi';
import { LoadingContext } from 'context/Loading/LoadingContext';
import { FormVendedor } from '@typings/cadastro';
import ButtonSecondary from 'components/Buttons/ButtonSecondary/ButtonSecondary.component';
import ButtonTerciary from 'components/Buttons/ButtonTerciary/ButtonTerciary.component';
import { eventManager, UPDATE_EVENTS } from 'utils/eventManager';

const api = useApi();

type TEditVendedorProps = {
  setEdit: () => void;
  dado: any;
  onUpdate?: () => void;
};

const EditVendedores = ({ setEdit, dado, onUpdate }: TEditVendedorProps) => {
  const [active, setSalvar] = useState(false);

  const {
    loading,
    setLoading,
    loadingMensagem,
    setLoadingMensagem,
    loadingBtn,
    setLoadingBtn,
    loadingAction,
    setLoadingAction,
    clearLoading,
    setClearLoading,
  }: any = React.useContext(LoadingContext);

  const isBreak = useScreenSize(570);
  const schema = z.object({
    nome: z.string().nonempty({ message: 'O nome é obrigatório.' }),
    emailContato: z.string().nonempty({ message: 'O E-mail é obrigatório.' }),
    contato: z.string().nonempty({ message: 'O contato é obrigatório.' }),
    documento: z.string().nonempty({ message: 'O documento é obrigatório.' }),
    endereco: z.string().nonempty({ message: 'O endereco é obrigatório.' }),
    telefone: z.string().nonempty({ message: 'O telefone é obrigatório.' }),
    comissao: z.string().nonempty({ message: 'A comissao é obrigatório.' }),
    tipoDocumentoo: z.string().nonempty({ message: 'O tipo de documento é obrigatório.' }),
  });

  const { clearErrors, handleSubmit, setValue, formState, watch } = useForm({
    defaultValues: {
      comissao: dado.comissao || '',
      nome: dado.nome || '',
      emailContato: dado.emailContato || '',
      contato: dado.contato || '',
      documento: dado.documento || '',
      endereco: dado.endereco || '',
      telefone: dado.telefone || '',
      tipoDocumentoo: dado.tipoDocumentoo || '',
    },
    resolver: zodResolver(schema),
  });

  const dadosForm = [
    { label: 'Nome do vendedor', type: 'text', campo: 'nome', select: false, option: [] },
    { label: 'E-mail do vendedor', type: 'text', campo: 'emailContato', select: false, option: [] },
    { label: 'Contato', type: 'text', campo: 'contato', select: false, option: [] },
    { label: 'Documento', type: 'text', campo: 'documento', select: false, option: [] },
    { label: 'Endereço', type: 'text', campo: 'endereco', select: false, option: [] },
    { label: 'Comissão', type: 'number', campo: 'comissao', select: false, option: [] },
    { label: 'Tipo de Documento', type: 'text', campo: 'tipoDocumentoo', select: false, option: [] },
  ];

  const onSubmit = async (data) => {
    setLoading(true);
    const arrReq = {
      nome: watch('nome'),
      emailContato: watch('emailContato'),
      comissao: Number(watch('comissao')),
      contato: watch('contato'),
      telefone: watch('telefone'),
      documento: watch('documento'),
      tipoDocumentoo: watch('tipoDocumentoo'),
      endereco: watch('endereco'),
    };
    try {
      const msg = 'Atualizado com sucesso!';
      await api
        .patch(`/vendedor/${dado.id}`, arrReq)
        .then((response) => {
          setLoadingMensagem(msg);
          setLoadingBtn('OK');
          setLoading(false);

          const usuarioLogado = JSON.parse(sessionStorage.getItem('user') || '{}');
          if (usuarioLogado && usuarioLogado.id === dado.id) {
            const dadosAtualizados = { ...usuarioLogado, ...response.mensagem };
            sessionStorage.setItem('user', JSON.stringify(dadosAtualizados));
            console.log('SessionStorage atualizado com dados do vendedor atualizado');
          }

          eventManager.dispatchUpdateEvent(UPDATE_EVENTS.VENDEDOR_UPDATED, {
            vendedorId: dado.id,
            vendedorData: response.mensagem || arrReq,
          });

          if (onUpdate) {
            onUpdate();
          }
          setEdit();
        })
        .catch((err) => {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          const msg_ = 'Houve um erro interno, tente mais tarde. ' + err.message;
          setLoadingMensagem(msg_);
          setLoadingBtn('OK');
          setLoading(false);
        });
    } catch (e) {
      let msg = 'Houve um erro interno, tente mais tarde. ' + e.message;
      if (e.response.data.message === 'Unauthorized') {
        msg = 'Usuário não autorizado';
        setLoadingAction('/admin/sair');
      }

      setLoadingMensagem(msg);
      setLoadingBtn('OK');
    }
  };

  function handleChange(name: FormVendedor, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const value = event.target.value;

    setValue(name, value);

    if (formState.errors[`${name}`]) {
      clearErrors(name);
    }
  }

  const isCampoInFormCliente = (campo: string): campo is FormVendedor => {
    return (
      campo === 'nome' ||
      campo === 'emailContato' ||
      campo === 'comissao' ||
      campo === 'contato' ||
      campo === 'documento' ||
      campo === 'endereco' ||
      campo === 'telefone' ||
      campo === 'tipoDocumentoo'
    );
  };

  return (
    <Stack spacing={2}>
      <FormGlobal noValidate onSubmit={handleSubmit(onSubmit)}>
        {dadosForm &&
          dadosForm.map((dados, index) => (
            <>
              <TextInputField
                key={index}
                label={dados.label}
                type={dados.type}
                selected={dados.select}
                nome={dados.campo}
                dados={dados.option}
                mask={maskInput(dados.campo)}
                style={{ width: isBreak ? '100%' : '49%' }}
                defaultValueText={'-- Selecione --'}
                value={
                  isCampoInFormCliente(dados.campo)
                    ? dados.campo === 'documento'
                      ? maskCpfCnpj(watch(dados.campo))
                      : watch(dados.campo)
                    : null
                }
                error={!!formState.errors[dados.campo]}
                helperText={formState.errors[dados.campo] ? formState.errors[dados.campo].message : ''}
                onChange={(nome) => (isCampoInFormCliente(dados.campo) ? handleChange(dados.campo, nome) : null)}
              />
            </>
          ))}
        <div style={{ marginTop: '30px' }}>
          <ButtonPrimary typeSubmit label={'Atualizar cadastro'} />
        </div>
      </FormGlobal>
      <ButtonTerciary onClick={setEdit} label={'Cancelar'} typeSubmit={false} />
    </Stack>
  );
};
export default EditVendedores;
